define.alias("shared/components/shared/bttp/bttp-suggestions", "preview-grid/components/shared/bttp/bttp-suggestions");